import { DROPDOWN_FIRST_INDEX } from '../../constant/product-option';
import { SelectBoxDropdownItem } from '../../type/common.type';

/**
 * 현재 선택된 옵션에 품절 상품이 있는지 확인합니다.
 * BOGO 프로모션이 있어도 모든 그룹이 동일한 데이터를 가지므로 첫 번째 그룹만 확인합니다.
 * @param option_dropdown_list - 옵션 드롭다운 리스트 (항상 2차원 배열)
 * @param selected_dropdown_index - 현재 선택된 인덱스
 * @returns 품절 상품이 있는지 여부
 */
export const hasSoldOutOptionsInCurrentSelection = (
  option_dropdown_list: SelectBoxDropdownItem[][],
  selected_dropdown_index: number,
): boolean => {
  const active_group = option_dropdown_list[DROPDOWN_FIRST_INDEX] ?? [];
  const sold_out_count = getSoldOutOptionsCount(active_group, selected_dropdown_index);
  return sold_out_count > 0;
};

/**
 * 현재 선택된 옵션의 품절 상품 수를 반환합니다
 * @param dropdown_group - 드롭다운 그룹
 * @param selected_dropdown_index - 현재 선택된 인덱스
 * @returns 품절 상품 수
 */
const getSoldOutOptionsCount = (dropdown_group: SelectBoxDropdownItem[], selected_dropdown_index: number): number => {
  const current_dropdown = dropdown_group[selected_dropdown_index];
  if (!current_dropdown?.data) {
    return 0;
  }

  return current_dropdown.data.filter((option) => option.option.stock_status?.is_sold_out).length;
};
